import { Components, Theme } from '@mui/material';

export function getMuiLinearProgress(
  theme: Theme,
): Components['MuiLinearProgress'] {
  return {
    defaultProps: {
      variant: 'determinate',
    },
    styleOverrides: {
      root: {
        height: 8,
        borderRadius: 6,
        backgroundColor: theme.palette.background.default,
      },
    },
  };
}
